"use client";
import React from "react";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import CompanySection from "./components/CompanySection";
import FeaturedJobs from "./components/FeaturedJobs";
import Footer from "./components/Footer";


function Home() {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@700&family=Epilogue:wght@400;500;700&family=Clash+Display:wght@400;500;700&display=swap"
      />

      <main className="overflow-hidden relative w-full min-h-screen bg-slate-50">
        <HeroSection />
        <CompanySection />
        <FeaturedJobs />
        <Footer />
      </main>
    </>
  );
}

export default Home;